import React from 'react'
import ShippersDocuments from './ShippersDocuments'
import CarriersDocuments from './CarriersDocuments'

const DetailDocuments = (props) => {
  const { transaction } = props

  return (
    <>
      <div className="d-flex row mb-32">
        <ShippersDocuments transaction={transaction} />
        <CarriersDocuments transaction={transaction} />
      </div>
    </>
  )
}

export default React.memo(DetailDocuments)
